
import { Component, Vue } from 'vue-property-decorator'

import authModule from '@/store/auth'
import whitelabelModule from '@/store/whitelabel'
import dashboardModule from '@/store/dashboard'
import dealModule from '@/store/deal'
import { TextFieldRules, Gender, GenderText } from '@/utils/enums'
import { Notification } from '@/types/Types'
import axios from 'axios'

@Component({
  name: 'NotificationEditor'
})
class NotificationEditor extends Vue {
  private rules = TextFieldRules
  private loading = false
  private categories = []

  private form: Notification = {
    deal: '',
    title: '',
    body: '',
    audience: {
      age: [18, 50],
      gender: Object.values(Gender),
      categories: []
    }
  }

  private get isSuperadmin() {
    return authModule.isSuperadmin
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private get whitelabels() {
    return whitelabelModule.whitelabels
  }

  private get deals() {
    return dealModule.deals
  }

  private get gender() {
    return Object.entries(Gender).map(entry => [GenderText[entry[0]], entry[1]])
  }

  private async created() {
    await dealModule.fetchAll({ limit: 0, lean: true })

    const { data } = await axios.get(
      `/admin/${this.whitelabel.slug}/category/list`
    )
    this.categories = data.categories
  }

  private async sendNotification() {
    this.loading = true
    try {
      const { data } = await axios.post(
        `/admin/${this.whitelabel._id}/audience`,
        this.form
      )
      dashboardModule.newMessage(
        `Diese Benachrichtigung hat ${data.results} Nutzer erreicht`
      )
    } catch (error) {
      dashboardModule.newError('Benachrichtigung konnte nicht gesendet werden')
    }
    this.loading = false
  }
}

export default NotificationEditor
